export * from './lib/components/add/add.component';
export * from './lib/core-ui-table-actions.module';
export * from './lib/models/desconto.models';
